import dynamic from "next/dynamic";
import { useState } from "react";
import MapControlToggle from "../Map/MapControlToggle";
import MapOverlay from "../Map/MapOverlay";
import MapLayout from "../Map/MapLayout";

const Map = dynamic(() => import("../Map/Map"), { ssr: false });

export default function LocationPageIndexMap({ locations, labels }) {
  const [state, setState] = useState("centers");

  const centers = locations.filter(
    (location) =>
      location.type.value === "center" || location.type.value === "sub_center",
  );
  const locationsWithMemorial = locations.filter((location) => location.has_memorial);
  const placeOfHomeLocations = locations.filter((location) => location.is_place_of_home);

  const memorialMarkers = locationsWithMemorial.map((location) => ({
    title: location.title,
    latitude: location.latitude || "0",
    longitude: location.longitude || "0",
    icon: "memorial",
  }));

  const placeOfHomeMarkers = placeOfHomeLocations.map((location) => ({
    title: location.title,
    latitude: location.latitude || "0",
    longitude: location.longitude || "0",
    icon: "circle",
  }));

  const handleMapControl = (option) => {
    switch (option) {
      case 0:
        setState("centers");
        break;
      case 1:
        setState("places_of_home");
        break;
      case 2:
        setState("memorials");
        break;
    }
  };

  const getMapMarkers = () => {
    if (state === "places_of_home") return placeOfHomeMarkers;
    if (state === "memorials") return memorialMarkers;
    return [];
  };

  return (
    <MapLayout>
      <Map markers={getMapMarkers()} centers={state === "centers" ? centers : []} />
      <MapOverlay className="left-0">
        <MapControlToggle
          options={[
            labels["show-centers"],
            labels["show-places-of-home"],
            labels["show-memorials"],
          ]}
          onChange={handleMapControl}
        />
      </MapOverlay>
    </MapLayout>
  );
}
